<template>
  <header :class="headerClass">
    <h1>
      <router-link to="/">
        <span v-if="props.isLogo !== 0" class="sub-logo"
        ><img src="@assets/img/logo.svg" alt="로고"
        /></span>
        <span v-if="props.isLogo === 0" class="main-logo">HOME</span>
      </router-link>
    </h1>
    <ResponsiveNav />
    <div class="login-box" v-if="!commonStore.isSignIn">
      <router-link :to="{ name: ROUTE_NAME.SignIn }">LOGIN</router-link>
    </div>
    <div class="login-box" v-if="commonStore.isSignIn">
      <button type="button" @click="handleSignOut">LOGOUT</button>
    </div>
  </header>
</template>
<script setup lang="ts">
import { ROUTE_NAME } from '@constants';
import { useAlertStore, useCommonStore } from '@stores';
import { useSignOut } from '@composables';
import { useRouter } from 'vue-router';
import ResponsiveNav from '@components/common/responsive/ResponsiveNav.vue';
import { computed } from 'vue';
import router from '@infra/router';

const props = defineProps<{
  isLogo: number;
}>();

const commonStore = useCommonStore();
const { handleSignOut: signOut } = useSignOut();
const { push } = useRouter();
const alertStore = useAlertStore();

const isMain = computed(() => {
  return router.currentRoute.value.name === ROUTE_NAME.Main;
});
const headerClass = computed(() => {
  if (isMain.value) {
    return 'header-isMain';
  } else {
    return 'header';
  }
});

const handleSignOut = async () => {
  if (!(await alertStore.showConfirmDialog('로그아웃 하시겠습니까?'))) {
    return;
  }
  await signOut();
  await push({ name: ROUTE_NAME.Main });
};
</script>

<style scoped lang="scss">
//main
.header-isMain {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 88px;
  min-width: 1280px;
  z-index: 5;
}

.header-isMain h1 {
  position: absolute;
  left: clamp(1.6875rem, -10.4375rem + 15.1562vw, 7.75rem);
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
  color: #fff;
  filter: brightness(0) contrast(100) invert(1);
}

.header-isMain .login-box {
  position: absolute;
  right: clamp(1.6875rem, -10.4375rem + 15.1562vw, 7.75rem);
  top: 50%;
  transform: translateY(-50%);
  border-radius: 60px;
  background-color: rgba(255, 255, 255, 0.08);
  color: #fff;
  width: 96px;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  z-index: 5;

  a {
    display: block;
  }
}

.main-logo {
  font-size: 18px;
  width: 160px;
  text-align: center;
  display: block;
}

//메인헤더+hover
.header-isMain:hover {
  background-color: #fff;
}

.header-isMain:hover h1 {
  color: var(--color-main);
  filter: none;
}

.header-isMain:hover .login-box {
  background-color: #ecf4ff;
  color: #222;
}

//the others
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 88px;
  min-width: 1280px;
  background-color: #fff;
  z-index: 5;
  border-bottom: 1px solid #ddd;
}

.header h1 {
  position: absolute;
  left: clamp(1.6875rem, -10.4375rem + 15.1562vw, 7.75rem);
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
}

.header .login-box {
  position: absolute;
  right: clamp(1.6875rem, -10.4375rem + 15.1562vw, 7.75rem);
  top: 50%;
  transform: translateY(-50%);
  border-radius: 60px;
  background-color: #ecf4ff;
  width: 96px;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  z-index: 5;
}
</style>
